module.exports = __webpack_public_path__ + "assets/pdf.7e6ae0e3.svg";